module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_16.de9c89b9.png";